import { Typography } from "@material-ui/core";
import clsx from "clsx";
import SlickSlider from "components/generics/SlickSlider";
import CoachCard from "./CoachCard";

function MeetOurCoaches({
    data,
}) {
    
    return (
        <div className="max-width">
            <div className={clsx("sectionGap",)}>
                <Typography
                    variant="h2"
                    className="center mtb20"
                >
                    {data.title}
                </Typography>
                {/* <div> */}
                <SlickSlider
                    data={data.coaches_list}
                    CardComponent={CoachCard}
                    slidesToShow={3}
                />
            </div>
            {/* </div> */}
        </div>
    )
}

export default MeetOurCoaches;